import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, InlineLink, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { openInNewTab, resetStreamOn, setStreamOnPageStatistics } from '@app/redux';

import { StreamOnStatus } from '@mfe/shared/schema-types';

import styles from '../styles.module.scss';

const StreamCardFooter = ({ state }: { state: StreamOnStatus }): JSX.Element | null => {
  const { t } = useTranslation('StreamOn');
  const dispatch = useDispatch();

  const goToFAQ = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const streamHelpUrl = t('streamOnFAQsLink', { ns: 'Global' });
    dispatch(openInNewTab(streamHelpUrl));
  };

  const refreshPage = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    dispatch(resetStreamOn());
    dispatch(setStreamOnPageStatistics());
  };

  if (state === StreamOnStatus.RequestErrored) {
    return (
      <div id="StreamOnFooter" className={`${styles['streamOnFooter']} ${styles['timeout']}`}>
        <Button onClick={refreshPage} className={styles['streamFooterButton']} variant="secondary">
          {t('Footer.refresh')}
        </Button>
      </div>
    );
  }

  return (
    <div id="StreamOnFooter" className={styles['streamOnFooter']}>
      <Txt variant="bodySmallBold" color="inherit">
        {t('Footer.needHelp')}
        <InlineLink id="footerLink" href="#" onClick={goToFAQ}>
          {t('Footer.streamOnHelp')}
        </InlineLink>
      </Txt>
    </div>
  );
};

export default StreamCardFooter;
